import React from 'react'

import { Route, Routes } from 'react-router-dom'
import Landing from './pages/landing.js'
import NoMatch from './pages/noMatch.js'
import GglChoice from './pages/gglChoice.js'
import GglMap from './pages/ggl.js'

import {
    Size_Unit,
    NumStrand_Clr,
    LinePost,
    CornerPost,
    Gate,
    EndPost,
    Kit_Insul,
} from './pages/pages.js'

// TODO: 06/17/24 allow for a refresh of the map when backing into from remote link
// TODO: 06/17/24 allow for prevous when sent a link if on the final page or just accept sending them a link with all filled out and yet starting on pg 2

import BOM from './pages/bom.js'
// import CheckoutCancel from './pages/cancel.js'
// import CheckoutSuccess from './pages/success.js'

function App() {
    return (
        <Routes>
            <Route path="/" element={<Landing />}>
                {/* ie permanent breadcrumbs etc */}
                <Route index element={<GglChoice />} />
                <Route path="pgGglMap" element={<GglMap />} />
                <Route path="pg2" element={<Size_Unit />} />
                <Route path="pg3" element={<NumStrand_Clr />} />
                <Route path="pg4" element={<LinePost />} />
                <Route path="pg5" element={<CornerPost />} />
                <Route path="pg6" element={<Gate />} />
                <Route path="pg7" element={<EndPost />} />
                <Route path="pg8" element={<Kit_Insul />} />
                <Route path="pg9" element={<BOM />} />
                {/* <Route path="pg_success" element={<CheckoutSuccess />} /> */}
                {/* <Route path="pg_cancel" element={<CheckoutCancel />} /> */}
                <Route path="*" element={<NoMatch />} />
            </Route>
            <Route path="*" element={<NoMatch />} />
        </Routes>
    )
}

export default App
